import React from 'react';

import { ReactComponent as Calendar } from 'assets/icons/automatic-buy-calendar.svg';

const ExchangeInstructionContent = (accountName) => {
  return {
    title: 'Exchange existing T. Rowe Price investments',
    subtitle: <span>To fund your brokerage account, you must first transfer assets into your <span id="funding-modal-step-2-accountName">{accountName}</span> sweep account. Eligible assets can be exchanged from your existing investments into an account of the same type.</span>,
    steps: [
      {
        content:
          "Choose the investment and the amount of assets you would like to exchange from"
      },
      {
        content:
          'Select your sweep fund, which will be linked to your new account, to receive your assets'
      }
    ],
    notes: [
      {
        moneyMarketContent:
          'Exchange requests made during market hours are generally processed the same day at 5 p.m. ET. You can also purchase additional shares of brokerage investments using assets held in your sweep account.',
        content: 'Exchange requests made during market hours are generally processed the same day at 4 p.m. ET. You can also purchase additional shares of brokerage investments using assets held in your sweep account.',
        icon: <Calendar className="mission-icon" />
      }
    ]
  };
};

export default ExchangeInstructionContent;
